<!-- 批量修改 -->
<template>
  <div class="createBatchProducts">
    <div>
      <el-steps :active="active" align-center>
        <el-step title="1.导出商品数据">
          <i class="step01" slot="icon"></i>
        </el-step>
        <el-step title="2.维护商品修改数据表">
          <i class="step02" slot="icon"></i>
        </el-step>
        <el-step title="3.上传数据表"><i class="step03" slot="icon"></i></el-step>
        <el-step title="4.完成">
          <i class="step05" slot="icon"></i>
        </el-step>
      </el-steps>
    </div>
    <div
      class="my-content-box"
      v-loading="uploadLoading"
      element-loading-text="文件上传中，请耐心等待"
    >
      <div class="e-content" v-if="!succeedVisible">
        <h3 style="line-height: 1;">上传文件：</h3>
        <div class="upload-content">
          <div class="upload-btn">
            <el-upload
              ref="uploadFile"
              class="upload-demo"
              :http-request="uploadFile"
              :file-list="fileList"
              :auto-upload="false"
              :on-change="onChange"
              :on-success="handleFileSuccess"
              :before-remove="beforeRemove"
              :on-remove="handleRemove"
              :headers="headers"
              name="fileList"
              action=""
              :limit="limit"
              accept=".xlsx,xls"
            >
              <el-button size="small" type="primary">选择文件</el-button>
              <div slot="tip" class="el-upload__tip" v-if="ifSubmit">
                请先
                <span class="link" @click="downloadTmp">下载商品修改模板</span>
              </div>
            </el-upload>
          </div>
          <div class="upload-tips">
            <div>
              <i class="el-icon-warning-outline"></i>
            </div>
            <div>
              <p>温馨提示：</p>
              <p>1. excel格式必须是或者xlsx或者xls，属性条数≤3000条。</p>
              <p>2. 必填字段不能为空（必填字段名称前面带*），否则将导入失败。</p>
              <p>
                3.
                批量修改内容包括：库存、发货周期、市场价、订单是否确认、起订量，可先在商品列表中导出需修改的商品数据后，修改上传。
              </p>
            </div>
          </div>
          <div class="upload-btn-import">
            <el-button
              class="return-product"
              icon="el-icon-arrow-left"
              @click="goToUrl('/goodsMaintenance')"
            >
              返回
            </el-button>
            <el-button @click="submitUpload" type="primary" :disabled="ifSubmit">上 传</el-button>
          </div>
        </div>
      </div>

      <!-- 
        上传完成/成功和失败
      -->
      <div class="data-ok" v-if="succeedVisible">
        <h3>上传完成：</h3>
        <div class="alert">
          <i class="el-icon-circle-check" v-if="isFail"></i>
          <i class="el-icon-circle-close" v-if="!isFail"></i>
          <span v-if="isFail">商品数据编辑成功</span>
          <span v-if="!isFail">商品数据编辑失败</span>
        </div>
        <ul class="xlsx-list">
          <li class="item" v-for="(item, index) of currentTableHistoryData" :key="index">
            <div>第{{ item.no }}行</div>
            <div>
              {{ item.errorInfo }}
            </div>
          </li>
        </ul>
        <div class="data-btn">
          <el-button type="primary" @click="handleContinueUpload">继续批量修改</el-button>
          <el-button type="primary" @click="goToUrl('/goodsMaintenance')">返回</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from '../../utils/utils';
import api from '../../api/product';
import { epecToken } from '../../utils/globalData';
console.log(api);
export default {
  data() {
    return {
      // 展示上传成功列表
      succeedVisible: false,
      // 上传加载loading
      uploadLoading: false,
      // 是否展示上传历史信息
      tableShow: false,
      // 成功之后展示的icon
      iocnShow: false,
      // 上传完成之后后台返回的当前上传数据
      currentTableHistoryData: [],
      tableHistoryData: [],
      tableData: [],
      listQuery: {
        pageNum: 1,
        pageSize: 10,
      },
      cloneListQuery: {},
      total: 0,
      ifSubmit: true,
      active: 10,
      // 请求头信息
      headers: epecToken,
      // 上传文件的数量
      limit: 10,
      // 上传的文件列表,文件编辑回显的时候用到
      fileList: [],
      // 限制文件上传的大小
      fileSize: 5,
      dialogFormVisible: false,
      selectOptions: [],
      value: '',
      downloadQuery: {},
      clickableUpload: false,
      rules: {
        categoryId: [{ required: true, message: '请选择分类名称', trigger: 'change' }],
      },
      classifyForm: {
        categoryId: '',
      },
      isFail: false,
    };
  },
  /* computed: {
    isFail() {
      const failArr = this.currentTableHistoryData.filter(item => {
        return item.errorInfo;
      });
      return failArr.length === 0;
    },
  }, */
  created() {
    const { cloneDeep } = utils;
    this.cloneListQuery = cloneDeep(this.listQuery);
    this.getHistoryList(this.listQuery);
    this.getSelectLeafCategoryList();
  },
  methods: {
    // 获取商品下载分类名称列表
    async getSelectLeafCategoryList() {
      const { selectLeafCategoryList } = api;
      const res = await selectLeafCategoryList();
      console.log(res, 'sdfdfd');
      this.selectOptions = [...res.data];
    },
    // 跳转链接
    goToUrl(url) {
      this.$router.push({ path: url });
    },
    async getHistoryList(params) {
      try {
        await api.selectSkuImportFilePage(params).then(res => {
          if (res.code === '200') {
            const data = res.data;
            this.tableHistoryData = [...data.records];
            this.total = data.total;
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    // 继续下载按钮操作
    handleContinueUpload() {
      this.succeedVisible = false;
    },
    // 处理历史列表
    tableHistoryShwo() {
      this.tableShow = !this.tableShow;
      this.iocnShow = !this.iocnShow;
      this.tableShow
        ? (this.$refs.uploadHistory.style['border-bottom'] = 'none')
        : (this.$refs.uploadHistory.style['border-bottom'] = '1px solid #ccc');

      this.$refs.uploadHistory;
    },
    // 列表相关方法
    async getList(params) {
      console.log(params);
    },
    handleCurrentChange(val) {
      this.listQuery.pageNum = val;
      this.getHistoryList(this.listQuery);
    },
    handleSizeChange(val) {
      this.listQuery.pageSize = val;
      this.listQuery.pageNum = 1;
      this.getHistoryList(this.listQuery);
    },
    selectChange(value) {
      console.log(value);
      console.log(this.selectOptions);
      const [selectParam] = this.selectOptions.filter(item => item.categoryId === value);
      this.downloadQuery = { ...selectParam };
      console.log(this.downloadQuery);
    },
    cancelHandle() {
      this.$refs.classifyForm.resetFields();
      this.dialogFormVisible = false;
    },
    // 下载模版
    async downloadTmp() {
      const res = await api.downProductEditTemplate({});
      if (res.size !== 0) {
        utils.downFile(res, `商品维护模板`);
      }
    },
    // 上传文件提交
    submitUpload() {
      // 通过 FormData 对象上传文件
      const fileList = new FormData();
      // 执行文件上传的函数，其实也就是调用 uploadFile方法 来获取我们要上传的文件
      this.$refs.uploadFile.submit();
      this.fileList.forEach(function(file) {
        // 因为要上传多个文件，所以需要遍历
        fileList.append('file', file, file.name);
      });
      this.uploadLoading = true;
      api
        .importSkuEdit(fileList)
        .then(res => {
          if (res.code === '200') {
            const data = res.data;
            this.currentTableHistoryData = [...data];
            // 成功
            this.isFail = data.length === 0;
          } else {
            this.isFail = false;
            this.currentTableHistoryData = [];
          }
        })
        .finally(() => {
          this.uploadLoading = false;
          this.succeedVisible = true;
          this.fileList = [];
          this.ifSubmit = true;
          this.$refs.uploadFile.clearFiles();
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 下载失败的文件
    downloadFile(url) {
      window.open(url);
    },

    // 文件fliesize及格式校验
    isFileSize(file) {
      if (file.size / 1024 / 1024 > this.fileSize) {
        this.$message({
          message: `请上传小于${this.fileSize}M的文件!`,
          type: 'error',
        });
        return false;
      }
      if (file.name.includes(',')) {
        this.$message({
          message: '文件名格式错误!',
          type: 'error',
        });
        return false;
      }
      return true;
    },
    // 以下是上传文件需要的方法
    commonHandleCheck(val) {
      let testmsg = val.substring(val.lastIndexOf('.') + 1);
      testmsg && (testmsg = testmsg.toLowerCase());
      return testmsg;
    },

    // 验证调删除事件时的文件规则
    fileFormat(file) {
      let testmsg = this.commonHandleCheck(file.name);
      const isXls = testmsg === 'xls';
      const isXlsx = testmsg === 'xlsx';
      return isXls || isXlsx;
    },
    // 改变文件的钩子
    onChange(file, fileList) {
      if (fileList.length !== 0) {
        this.ifSubmit = false;
      }
      let testmsg = this.commonHandleCheck(file.name);
      const isXls = testmsg === 'xls';
      const isXlsx = testmsg === 'xlsx';
      // 避免有些是手动上传文件，直接在on-change上进行文件校验
      if (!isXlsx && !isXls) {
        this.$message({
          message: '上传文件只能是xlsx、xls格式!',
          type: 'error',
        });
        fileList.length && this.$refs.uploadFile.clearFiles();
        return false;
      }
      if (!this.isFileSize(file)) {
        this.$message({
          message: `上传文件大小不能超过 ${this.fileSize}MB!`,
          type: 'error',
        });
        fileList.length && this.$refs.uploadFile.clearFiles();
        return false;
      }
      console.log('改变文件的钩子', fileList);
      // 只能上传excel
      return isXlsx || isXls;
    },
    // 上传成功的钩子
    handleFileSuccess(response, file, fileList) {
      this.$refs.uploadFile.clearFiles();
      // 不管成功还是失败都将弹窗中选择的文件清空
      for (let index = 0; index < fileList.length; index++) {
        fileList.splice(index, 1);
      }
      this.fileList = [];
      this.ifSubmit = true;
      console.log(file, fileList, '上传成功的钩子111');
    },
    // 移除前的钩子
    beforeRemove(file) {
      console.log(file, '移除前的钩子');
      if (this.fileFormat(file)) {
        // 删除提示
        return this.$confirm(`确定永久移除 ${file.name}？`, '提示');
      }
    },
    // 上传失败的钩子
    errFunction(file, fileList) {
      console.log(file, fileList);
      this.$message.error('上传失败');
    },
    // 移除的钩子
    handleRemove(file, fileList) {
      console.log(file, fileList);
      // 由于elemenUI上传文件之间的校验返回false就会触发删除事件
      console.log(file, fileList);
      if (fileList.length === 0) {
        this.ifSubmit = true;
      }
    },
    // 这里就是的到需要上传文件的集合
    uploadFile(params) {
      console.log(params);
      this.fileList.push(params.file);
    },
  },
};
</script>
<style lang="scss" scoped>
.createBatchProducts {
  .name {
    display: inline-block;
    line-height: 1;
  }
  .my-tooltip {
    display: inline-block;
  }
  .my-content-box {
    width: 100%;
    background: #fff;
    padding: 20px;
  }
  .pagination {
    margin-bottom: 0;
  }
  .e-content {
    width: 100%;
    background: #fff;
    margin-bottom: 20px;
    .salesScope {
      line-height: 1;
      margin: 22px 0;
      .salesScope-icon {
        height: 18px;
        width: 18px;
        border-radius: 50%;
        border: 1px solid #c5c5c5;
        text-align: center;
        line-height: 18px;
        font-size: 12px;
        color: #c5c5c5;
        margin: 0 20px 0 10px;
      }
    }
    ::v-deep .choose-btn {
      width: 80px;
      height: 30px;
      line-height: 30px;
      padding: 0;
      color: #fff;
      font-size: 14px;
    }
    .upload-tips {
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      background: #f4f7ff;
      padding: 20px 10px;
      .el-icon-warning-outline {
        margin-right: 10px;
        color: #2587ff;
        font-size: 18px;
      }
      p {
        font-size: 12px;
        color: #606266;
        margin-top: 10px;
      }
      p:first-child {
        margin-top: 0;
      }
    }
  }
  .upload-content {
    .upload-btn {
      display: flex;
      margin-top: 20px;
      .el-upload__tip {
        line-height: 1;
        margin: 20px 0;
        font-size: 14px;
        .link {
          color: #2587ff;
          cursor: pointer;
        }
      }
      .upload-demo {
        margin: 0 0 4px 0;
      }
    }
  }
  .upload-history {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    font-size: 14px;
    background: #fff;
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    color: #666;
  }
  .upload-btn-import {
    ::v-deep .el-button {
      width: 80px;
      height: 30px;
      padding: 0;
      line-height: 30px;
      margin-left: 0;
    }
    position: relative;
    margin-top: 18px;
    text-align: center;
    .return-product {
      position: absolute;
      left: 0;
      top: 0;
    }
  }
  .data-ok {
    padding: 18px;
    .alert {
      display: flex;
      justify-content: center;
      align-items: center;
      color: #333333;
      i {
        font-size: 36px;
        margin-right: 20px;
      }
      .el-icon-circle-check {
        color: #50aa43;
      }
      .el-icon-circle-close {
        color: #ef4c56;
      }
    }
    .xlsx-list {
      min-height: 180px;
      max-height: 360px;
      margin: 18px 0;
      overflow: auto;
      .item {
        margin: 8px 0;
        padding: 0 12px;
        display: flex;
        justify-content: space-around;
        align-items: center;
        font-size: 15px;
        color: #2782ec;
        &:nth-child(even) {
          background: #f5f5f5;
        }
        .el-icon-document {
          margin-right: 8px;
        }
        div:nth-of-type(1) {
          flex: 3;
        }
        div:nth-of-type(2) {
          flex: 2;
          color: #666;
          span {
            color: #ef4c56;
          }
        }
        div:nth-of-type(3) {
          flex: 1;
          text-align: right;
          ::v-deep .el-button--text {
            font-size: 15px;
            padding: 0;
          }
        }
      }
    }
    .data-btn {
      text-align: center;
    }
    .error {
      color: red;
    }
  }

  .step01,
  .step02,
  .step03,
  .step04,
  .step05 {
    width: 30px;
    height: 30px;
    background-size: 100% 100%;
  }
  .step01 {
    background-image: url('../../../../assets/img/icon-fenlei.png');
  }
  .step02 {
    background-image: url('../../../../assets/img/Union.png');
  }
  .step03 {
    background-image: url('../../../../assets/img/Vect.png');
  }
  .step04 {
    background-image: url('../../../../assets/img/Vecto.png');
  }
  .step05 {
    background-image: url('../../../../assets/img/Vector.png');
  }
  ::v-deep .el-steps {
    width: 100%;
    padding: 0 40px;
    margin-bottom: 20px;
    .el-step.is-horizontal .el-step__line {
      top: 50%;
    }
    .el-step__head.is-finish {
      border-color: #2587ff;
    }
    .el-step__title.is-finish {
      color: #2587ff;
    }
    .el-step__icon {
      width: 56px;
      height: 56px;
      background: #f0f0f0;
    }
    .el-step__icon.is-text {
      border: none;
    }
  }
  ::v-deep .el-steps {
    .el-step__title.is-finish {
      color: #333333;
    }
  }

  ::v-deep .el-steps .el-step__title {
    color: #333333 !important;
  }
}
</style>
